import { render, staticRenderFns } from "./registrationConfirmation.vue?vue&type=template&id=28da0d22&scoped=true&"
import script from "./registrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./registrationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./registrationConfirmation.vue?vue&type=style&index=0&id=28da0d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28da0d22",
  null
  
)

export default component.exports